import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

function since(d) {
  const a = new Date(`${d}T00:00:00`), b = new Date();
  let m = (b.getFullYear() - a.getFullYear()) * 12 + b.getMonth() - a.getMonth() - (b.getDate() < a.getDate() ? 1 : 0);
  if (m < 0) return null;
  const y = Math.floor(m / 12); m %= 12;
  return [y && `${y} year${y > 1 ? "s" : ""}`, m && `${m} month${m > 1 ? "s" : ""}`].filter(Boolean).join(", ") || "less than a month";
}

export default function PartnershipLaunch({ userId, value, canEdit, today, onSaved }) {
  const [d, setD] = useState(value || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setD(value || ""); }, [value]);
  const save = async () => {
    setBusy(true);
    try { await api.post(`/people/${userId}/milestone-profile`, { partnership_launch_date: d || null }); toast.success("Saved"); onSaved(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save"); }
    finally { setBusy(false); }
  };
  return (
    <section className="rounded-xl border border-[#C9A961]/50 bg-[#C9A961]/5 p-3 sm:p-4" data-testid="partnership-launch">
      <label htmlFor="pl-date" className="text-sm font-semibold text-[#0A1F44]">When did you launch into partnership?</label>
      <div className="flex flex-wrap items-center gap-2 mt-2">
        <Input id="pl-date" type="date" max={today} value={d} disabled={!canEdit} onChange={(e) => setD(e.target.value)} className="h-11 w-48" data-testid="partnership-launch-input" />
        {canEdit && d !== (value || "") && <Button onClick={save} disabled={busy} className="h-11 bg-[#0A1F44] text-white" data-testid="partnership-launch-save">Save</Button>}
      </div>
      {value && since(value) && <div className="text-xs text-slate-600 mt-1.5" data-testid="partnership-launch-since">In partnership for {since(value)}</div>}
      {!value && !canEdit && <div className="text-xs text-slate-500 mt-1">Not recorded yet</div>}
    </section>
  );
}
